import {mergeDeep, makeElement, addClass, removeClass, uniqueID} from '../../common/Utils';
import {ncBannerModalOptions} from '../../interface/ICommonbanner';

export default class AbsModal {
    static TYPE_MODAL = 'modal';
    static TYPE_TOAST = 'toast';

    type: string = '';
    isShowModal:boolean = false;
    modalEl!: HTMLElement;
    backdropEl!: HTMLElement;
    priBtn!: HTMLElement | null;
    secBtn!: HTMLElement | null;
    closeBtn!: HTMLElement | null;
    autoCloseTimeOut!: ReturnType<typeof setTimeout> | null;;
    initialOptions = {
        title: '',
        contents: '',
        className: '',
        primaryBtnText: '확인',
        cancelBtnText: '취소',
        usePrimaryBtn: true,
        useCancelBtn: true,
        useBackdropClickClose: true,
        useEscKeyClose: true,
        useEnterKeyClose: true,
        mobileFull: false,
        autoClose: 0,
        useBlur: true,
        position: 'center', // 'top', 'bottom'
        site: window.userData?.site || 'plaync',
        id: uniqueID('nc-modal_'),
        enableScroll: false,
        willOpen: ()=>{},
        didClose: ()=>{},
    };

    constructor(){}

    options!: ncBannerModalOptions;
    optionsSetting(_options={}){
        this.options = mergeDeep(this.initialOptions, _options);

    }

    makeBackdropEl(){
        this.backdropEl = makeElement( `<div id="${this.options.id}-backdrop" class="nc-backdrop${this.options.useBlur? ' nc-backdrop--blur' : ''}"></div>` );
        document.body.appendChild( this.backdropEl );
    }

    makeModalEl(){
        this.modalEl = this.template() as unknown as HTMLElement;
        document.body.appendChild( this.modalEl );
    }

    setBtns(){
        this.priBtn = this.modalEl!.querySelector(".nc-modal__btn--pri");
        this.secBtn = this.modalEl!.querySelector(".nc-modal__btn--sec");
        this.closeBtn = this.modalEl!.querySelector(".nc-modal__close");
    }

    addEvents(){
        document.addEventListener('keydown', (event) => {
            if (this.isShowModal && this.options.useEscKeyClose && event.keyCode === 27) { // escape
                this.close(false);
            }
            if (this.isShowModal && this.options.useEnterKeyClose && event.keyCode === 13) { // Enter
                this.close(true);
            }
        }, false);

        this.priBtn?.addEventListener('click', (e: Event) => this.close(true));
        this.secBtn?.addEventListener('click', (e: Event) => this.close(false));
        this.closeBtn?.addEventListener('click', (e: Event) => this.close(false));

        if (this.options.useBackdropClickClose) {
            this.modalEl?.addEventListener('click', (e: Event) =>{
                if( e.currentTarget == e.target ){
                    this.close(false);
                }
            });
        }
    }


    template(){
        const temp = `
        <div id="${this.options.id}" class="nc-modal nc-modal--${this.options.site} nc-modal--${this.options.position} ${this.options.className} ${this.options.enableScroll ? 'nc-modal--scroll' : ''}" tabindex="-1">
            <div class="nc-modal__dialog${this.options.mobileFull? ` nc-modal__dialog--full`: ``}" role="document">
                <div class="nc-modal__content${this.options.mobileFull? ` nc-modal__content--full`: ``}">
                    <div class="nc-modal__header">
                        <div class="nc-modal__title">${this.options.title}</div>
                    </div>
                    <div class="nc-modal__body">${this.options.contents}</div>
                    <div class="nc-modal__footer"></div>
                </div>
            </div>
        </div>`;
        return temp;
    }

    open(){
        if (this.isShowModal) return;
        this.isShowModal = true;
        this.options.willOpen?.();

        if (this.type !== AbsModal.TYPE_TOAST) {
            addClass( document.body, 'modal-open');
        }

        setTimeout(() => {
            addClass( this.modalEl, 'nc-modal--show');
            addClass( this.backdropEl, 'nc-backdrop--show');
        }, 1);

        setTimeout(() => {
            this.modalEl?.setAttribute( 'tabindex', "0" );
            this.modalEl?.focus();
        }, 100);

        if (this.options.autoClose!>100) {
            this.autoCloseTimeOut = setTimeout(() => this.close(false), this.options.autoClose);
        }
    }

    close(_result: boolean = true){
        if (!this.isShowModal) return;
        this.isShowModal = false;
        if (this.type !== AbsModal.TYPE_TOAST) {
            removeClass( document.body, 'modal-open' );
        }
        removeClass( this.modalEl, 'nc-modal--show');
        removeClass( this.backdropEl, 'nc-backdrop--show');

        if(this.autoCloseTimeOut)
        clearTimeout(this.autoCloseTimeOut);
        this.autoCloseTimeOut = null;

        this.options.didClose?.(_result);
    }

} // end of class
// TODO : 동영상 기능 추가
